module.exports = __webpack_public_path__ + "static/SVLogo-5ae42fdef9f128219660017a52278263.jpeg";